"use strict";

exports.__esModule = true;
var _TimeRangeKindSelector = require("./TimeRangeKindSelector");
Object.keys(_TimeRangeKindSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimeRangeKindSelector[key]) return;
  exports[key] = _TimeRangeKindSelector[key];
});